import { useUI } from "providers/UIProvider"

import { Box, FormControl, InputGroup, InputRightElement } from "@chakra-ui/react"

import Input from "components/UI/atoms/Input"
import Select from "components/UI/atoms/Select"
import { useEmployeesContext } from "providers/EmployeesProvider"

const EmployeeForm: React.FC<any> = ({ values, errors, touched, handleChange, handleBlur, setValues, setFieldTouched }: any) => {
  const { T } = useUI()

  const { employeePositions } = useEmployeesContext()

  const washerEmployee = employeePositions.find((employee: any) => employee.label === "მრეცხავი" || employee.label === "Washer" || employee.label === "employees.positions.Washer");
  const isWasherRoleId = values?.roleId === washerEmployee?.value


  return (
    <Box>
      <FormControl>
        <Input
          id="fullName"
          name="fullName"
          type="string"
          label={T("employees.form.name_label")}
          value={values.fullName}
          onChange={handleChange}
          onBlur={handleBlur}
          styles={{ width: "100%", height: "50px" }}
          error={Boolean(touched.fullName && errors.fullName)}
          errorMessage={errors.fullName}
        />
      </FormControl>
      <FormControl mt="15px">
        <Input
          id="personalCode"
          name="personalCode"
          type="string"
          label={T("employees.form.id_number_label")}
          value={values.personalCode}
          onChange={handleChange}
          onBlur={handleBlur}
          styles={{ width: "100%", height: "50px" }}
          error={Boolean(touched.personalCode && errors.personalCode)}
          errorMessage={errors.personalCode}
        />
      </FormControl>
      <FormControl mt="15px">
        <Input
          id="phoneNumber"
          name="phoneNumber"
          type="number"
          label={T("employees.form.phone")}
          value={values.phoneNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          styles={{ width: "100%", height: "50px" }}
          error={Boolean(touched.phoneNumber && errors.phoneNumber)}
          errorMessage={errors.phoneNumber}
        />
      </FormControl>
      <FormControl mt="15px">
        <Select
          value={values.roleId}
          label={T("employees.form.position")}
          placeholder={T("employees.form.choose_position")}
          onChange={(val: any) => setValues({ ...values, roleId: val.value })}
          onBlur={() => setFieldTouched("roleId")}
          options={employeePositions}
          inputStyles={{ width: "100%", height: "50px" }}
          error={Boolean(touched.roleId && errors.roleId) && errors.roleId}
          maxMenuHeight={120}
        />
      </FormControl>
      {isWasherRoleId &&
        <FormControl mt="15px">
          <InputGroup style={{ flexDirection: "column" }} >
            <Input
              id="salaryPercent"
              name="salaryPercent"
              type="number"
              label={T("employees.form.salaryPercent")}
              value={values.salaryPercent || ""}
              onChange={handleChange}
              onBlur={handleBlur}
              styles={{ width: "100%", height: "50px" }}
            />
            <InputRightElement style={{
              pointerEvents: "none",
              width: "7%",
              height: "103px",
              fontSize: "18px",
              zIndex: "0"
            }}
            >
              %
            </InputRightElement>
          </InputGroup>
        </FormControl>
      }
    </Box>
  )
}

export default EmployeeForm